// Hook do pobierania listy zadan - GET /sales-crm/tasks (uzywany m.in. w kalendarzu /trader/calendar).
// Filtrowanie po zakresie dat realizowane przez `filter[and][N][and][0][field|op|value]`
// (taki sam mechanizm jak w WiseTable advancedFiltersToParams).

import qs from 'query-string';
import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import { ISalesCrmTask } from 'api/endpoints/useGetSalesCrmTask';

export interface IGetSalesCrmTasksParams {
  page?: number;
  limit?: number;
  date_from?: string;
  date_to?: string;
  trader_id?: number;
  client_id?: number;
  type?: string;
  status?: string;
}

export interface IGetSalesCrmTasksResponse {
  page: number;
  total_count: number;
  total_pages: number;
  items: ISalesCrmTask[];
}

// Buduje plaska mape kluczy query-string zgodna ze skladnia backendu WiseB2B:
//   filter[and][0][and][0][field]=due_date&filter[and][0][and][0][op]=gte&...
const buildRangeFilter = (dateFrom?: string, dateTo?: string): Record<string, string> => {
  const flat: Record<string, string> = {};
  const conditions: { op: 'gte' | 'lte'; value: string }[] = [];

  if (dateFrom) conditions.push({ op: 'gte', value: dateFrom });
  if (dateTo) conditions.push({ op: 'lte', value: dateTo });

  conditions.forEach((cond, idx) => {
    const prefix = `filter[and][${idx}][and][0]`;
    flat[`${prefix}[field]`] = 'due_date';
    flat[`${prefix}[op]`] = cond.op;
    flat[`${prefix}[value]`] = cond.value;
  });

  return flat;
};

const getSalesCrmTasks = (params: IGetSalesCrmTasksParams): Promise<IGetSalesCrmTasksResponse> => {
  const { date_from, date_to, page, limit, trader_id, client_id, type, status } = params;

  const queryParams: Record<string, string | number | undefined> = {
    page,
    limit,
    trader_id,
    client_id,
    type,
    status,
    ...buildRangeFilter(date_from, date_to)
  };

  const queryString = qs.stringify(queryParams, {
    skipEmptyString: true,
    skipNull: true
  });

  return axios.get(`/sales-crm/tasks${queryString ? `?${queryString}` : ''}`);
};

export const useGetSalesCrmTasks = (
  params: IGetSalesCrmTasksParams = {},
  options?: UseQueryOptions<IGetSalesCrmTasksResponse, IError>
) =>
  useQuery<IGetSalesCrmTasksResponse, IError>(
    ['sales-crm', 'tasks', params],
    () => getSalesCrmTasks(params),
    options
  );
